const Delete = {
  sm: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M6.66667 12.0064C7.03533 12.0064 7.33333 11.7084 7.33333 11.3398V7.33976C7.33333 6.9711 7.03533 6.6731 6.66667 6.6731C6.298 6.6731 6 6.9711 6 7.33976V11.3398C6 11.7084 6.298 12.0064 6.66667 12.0064Z"
        fill="#A1A3A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M9.3339 12.0064C9.70257 12.0064 10.0006 11.7084 10.0006 11.3398V7.33976C10.0006 6.9711 9.70257 6.6731 9.3339 6.6731C8.96524 6.6731 8.66724 6.9711 8.66724 7.33976V11.3398C8.66724 11.7084 8.96524 12.0064 9.3339 12.0064Z"
        fill="#A1A3A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M11.0084 13.0339C10.9998 13.2033 10.8364 13.3359 10.6771 13.3346H5.31242C5.15909 13.3173 5.00509 13.2039 4.99642 13.0293L4.56442 5.33325H11.4224L11.0084 13.0339ZM6.66442 3.07725C6.66442 2.85459 6.85309 2.66659 7.07576 2.66659H8.92109C9.14776 2.66659 9.33242 2.85125 9.33242 3.07725V3.99992H6.66442V3.07725ZM13.3331 3.99992H12.1744C12.1704 3.99992 12.1664 3.99659 12.1618 3.99659C12.1538 3.99592 12.1471 3.99992 12.1384 3.99992H10.6658V3.07725C10.6658 2.11592 9.88376 1.33325 8.92109 1.33325H7.07576C6.11376 1.33325 5.33109 2.11592 5.33109 3.07725V3.99992H2.66642C2.29842 3.99992 1.99976 4.29792 1.99976 4.66658C1.99976 5.03525 2.29842 5.33325 2.66642 5.33325H3.22976L3.66509 13.0979C3.70709 13.9713 4.43909 14.6686 5.29176 14.6686C5.30376 14.6686 5.31576 14.6679 5.32776 14.6679H10.6611H10.6991C11.5658 14.6679 12.2984 13.9719 12.3404 13.1026L12.7578 5.33325H13.3331C13.7018 5.33325 13.9998 5.03525 13.9998 4.66658C13.9998 4.29792 13.7018 3.99992 13.3331 3.99992Z"
        fill="#A1A3A7"
      />
    </svg>
  ),
  md: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M6.66667 12.0064C7.03533 12.0064 7.33333 11.7084 7.33333 11.3398V7.33976C7.33333 6.9711 7.03533 6.6731 6.66667 6.6731C6.298 6.6731 6 6.9711 6 7.33976V11.3398C6 11.7084 6.298 12.0064 6.66667 12.0064Z"
        fill="#A1A3A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M9.3339 12.0064C9.70257 12.0064 10.0006 11.7084 10.0006 11.3398V7.33976C10.0006 6.9711 9.70257 6.6731 9.3339 6.6731C8.96524 6.6731 8.66724 6.9711 8.66724 7.33976V11.3398C8.66724 11.7084 8.96524 12.0064 9.3339 12.0064Z"
        fill="#A1A3A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M11.0084 13.0339C10.9998 13.2033 10.8364 13.3359 10.6771 13.3346H5.31242C5.15909 13.3173 5.00509 13.2039 4.99642 13.0293L4.56442 5.33325H11.4224L11.0084 13.0339ZM6.66442 3.07725C6.66442 2.85459 6.85309 2.66659 7.07576 2.66659H8.92109C9.14776 2.66659 9.33242 2.85125 9.33242 3.07725V3.99992H6.66442V3.07725ZM13.3331 3.99992H12.1744C12.1704 3.99992 12.1664 3.99659 12.1618 3.99659C12.1538 3.99592 12.1471 3.99992 12.1384 3.99992H10.6658V3.07725C10.6658 2.11592 9.88376 1.33325 8.92109 1.33325H7.07576C6.11376 1.33325 5.33109 2.11592 5.33109 3.07725V3.99992H2.66642C2.29842 3.99992 1.99976 4.29792 1.99976 4.66658C1.99976 5.03525 2.29842 5.33325 2.66642 5.33325H3.22976L3.66509 13.0979C3.70709 13.9713 4.43909 14.6686 5.29176 14.6686C5.30376 14.6686 5.31576 14.6679 5.32776 14.6679H10.6611H10.6991C11.5658 14.6679 12.2984 13.9719 12.3404 13.1026L12.7578 5.33325H13.3331C13.7018 5.33325 13.9998 5.03525 13.9998 4.66658C13.9998 4.29792 13.7018 3.99992 13.3331 3.99992Z"
        fill="#A1A3A7"
      />
    </svg>
  ),
}

export default Delete
